import { all, call, fork, takeEvery } from "redux-saga/effects";
import requestFunction from "../../Utils/sagaGenericFunction";
import { checkPaymentIntentFailure, checkPaymentIntentSuccess, createOpayPaymentFailure, createOpayPaymentSuccess, createPaymentIntentFailure, createPaymentIntentSuccess, updatePaymentIntentFailure, updatePaymentIntentSuccess } from "../Actions";
import { CheckPaymentIntentApi, CreateOpayPaymentApi, CreatePaymentIntentApi, UpdatePaymentIntentApi } from "../Api";
import { CHECK_PAYMENT_INTENT, CREATE_OPAY_PAYMENT, CREATE_PAYMENT_INTENT, UPDATE_PAYMENT_INTENT } from "../ActionTypes";

const createOpayPaymentWorker = function* ({ payload }) {
    // debugger
    yield call(requestFunction, createOpayPaymentSuccess, createOpayPaymentFailure, CreateOpayPaymentApi, payload);
};
export const createOpayPaymentWatcher = function* () {
    // debugger
    yield takeEvery(CREATE_OPAY_PAYMENT, createOpayPaymentWorker);
};
const createPaymentIntentWorker = function* ({ payload }) {
    // debugger
    yield call(requestFunction, createPaymentIntentSuccess, createPaymentIntentFailure, CreatePaymentIntentApi, payload);
};
export const createPaymentIntentWatcher = function* () {
    // debugger
    yield takeEvery(CREATE_PAYMENT_INTENT, createPaymentIntentWorker);
};
const checkPaymentIntentWorker = function* ({ payload }) {
    // debugger
    yield call(requestFunction, checkPaymentIntentSuccess, checkPaymentIntentFailure, CheckPaymentIntentApi, payload);
};
export const checkPaymentIntentWatcher = function* () {
    // debugger
    yield takeEvery(CHECK_PAYMENT_INTENT, checkPaymentIntentWorker);
};
const updatePaymentIntentWorker = function* ({ payload }) {
    // debugger
    yield call(requestFunction, updatePaymentIntentSuccess, updatePaymentIntentFailure, UpdatePaymentIntentApi, payload);
};
export const updatePaymentIntentWatcher = function* () {
    // debugger
    yield takeEvery(UPDATE_PAYMENT_INTENT, updatePaymentIntentWorker);
};


export default function* paymentSaga() {
    yield all([
        fork(createOpayPaymentWatcher),
        fork(createPaymentIntentWatcher),
        fork(checkPaymentIntentWatcher),
        fork(updatePaymentIntentWatcher),
    ]);
}